
import React from 'react';
import TerraceCard from './TerraceCard';
import { Terrace } from '@/types/terrace';

type TerraceListProps = {
  terraces: Terrace[];
  loading?: boolean;
}

const TerraceList: React.FC<TerraceListProps> = ({ terraces, loading = false }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 lg:gap-6">
        {[1, 2, 3, 4, 5, 6].map((_, i) => (
          <div key={i} className="h-64 sm:h-72 bg-muted animate-pulse rounded-lg"></div>
        ))}
      </div>
    );
  }

  if (!terraces.length) {
    return (
      <div className="text-center py-8 sm:py-10 px-4">
        <h3 className="text-base sm:text-lg font-medium mb-2">No sunny terraces found</h3>
        <p className="text-sm sm:text-base text-muted-foreground">
          Try adjusting your filters or check back later!
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4 lg:gap-6">
      {terraces.map(terrace => (
        <TerraceCard key={terrace.id} terrace={terrace} />
      ))}
    </div>
  );
};

export default TerraceList;
